module.exports = __webpack_public_path__ + "img/show1.24fd447b.png";